import { Module } from 'vuex';
import { RootState } from '@/store';
import { RunnersQuest } from '@/services/runners-quests/runners-quests.types';
import { RunnersQuestsService } from '@/services/runners-quests/runners-quests.service';

const runnersQuestsService = new RunnersQuestsService();

export interface RunnersQuestState {
  runnersQuestLoading: boolean;
  lastCreatedRunnersQuestId: number | null;
}

const state: RunnersQuestState = {
  runnersQuestLoading: false,
  lastCreatedRunnersQuestId: null
};

const options: Module<RunnersQuestState, RootState> = {
  namespaced: true,
  state: () => state,
  actions: {
    createRunnersQuest: ({ commit, dispatch }, serialNo: string): Promise<RunnersQuest | void> => {
      commit('setRunnersQuestLoading', true);
      return runnersQuestsService
        .create(serialNo)
        .then(rq => {
          if (rq) commit('setLastCreatedRunnersQuestId', rq.id);
          return rq;
        })
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('setRunnersQuestLoading', false));
    },
    deleteRunnersQuest: ({ commit, dispatch }, id: number): Promise<void> => {
      commit('setRunnersQuestLoading', true);
      return runnersQuestsService
        .delete(id)
        .then(() => commit('setLastCreatedRunnersQuestId', null))
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('setRunnersQuestLoading', false));
    },
    deleteRunnersQuestByBac: ({ commit, dispatch }, bac: string): Promise<void> => {
      commit('setRunnersQuestLoading', true);
      return runnersQuestsService
        .deleteByBac(bac)
        .then(() => dispatch('alert/pushSuccess', 'Runners quest supprime', { root: true }))
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('setRunnersQuestLoading', false));
    }
  },
  mutations: {
    setRunnersQuestLoading: (state, loading: boolean) => (state.runnersQuestLoading = loading),
    setLastCreatedRunnersQuestId: (state, id: number | null) => (state.lastCreatedRunnersQuestId = id)
  }
};

export default options;
